import {
  StyleSheet,
  Text,
  Animated,
  TouchableOpacity,
  ViewStyle,
  StyleProp,
  TextStyle,
  View,
  ActivityIndicator,
} from "react-native";
import React, { ReactNode, useRef } from "react";
import { ColorSpace } from "react-native-reanimated";
import { Colors } from "../../globalStyles/ColorConfig";

interface AnimatedPressableProps {
  onPress?: () => void;
  name: string;
  icon?: ReactNode;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  disableAnimation?: boolean;
  isLoading?: boolean;
}

const AppBtn: React.FC<AnimatedPressableProps> = ({
  onPress,
  name,
  icon,
  style,
  textStyle,
  disableAnimation = false,
  isLoading = false
}) => {
  const scaleValue = useRef(new Animated.Value(1)).current;
  const handlePressIn = () => {
    if (!disableAnimation) {
      Animated.spring(scaleValue, {
        toValue: 0.95,
        useNativeDriver: false,
      }).start();
    }
  };
  const handlePressOut = () => {
    if (!disableAnimation) {
      Animated.spring(scaleValue, {
        toValue: 1,
        useNativeDriver: false,
      }).start();
    }
  };
  return (
    <TouchableOpacity
      onPress={onPress}
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
      activeOpacity={0.8}
    >
      <Animated.View
        style={[
          { transform: [{ scale: disableAnimation ? 1 : scaleValue }] },
          styles.container,
          style,
        ]}
      >
        {icon && 
          <View style={{flex: 0.5,alignItems: 'center'}}>
            {icon}
          </View>
        }
        <View style={{flex:4}}>
          <Text style={[styles.text, textStyle]}>{name}</Text>
        </View>
        {isLoading && (
          <View style={{position: 'absolute', right: 20, height: '100%'}}>
            <ActivityIndicator size="large" color={Colors.white000} />
          </View>
        )}
      </Animated.View>
    </TouchableOpacity>
  );
};

export default AppBtn;

const styles = StyleSheet.create({
  container: {
    paddingVertical: 20,
    backgroundColor: "#D9D9D9",
    borderRadius: 5,
    flexDirection: "row",
    paddingHorizontal: 30,
    alignItems: "center",
    gap: 6*6
  },
  text: {
    fontSize: 16
  },
});